
import { motion } from 'framer-motion';

const BooksHero = () => {
  return (
    <section className="relative h-[60vh] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9d76522ccc40ae8264898d22eb29fc6e.jpg"
          alt="Books Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative h-full flex items-center justify-center px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-center max-w-4xl"
        >
          <h1 className="font-playfair text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            PUBLISHED WORKS
          </h1>
          <p className="font-lora text-xl text-white/90 leading-relaxed">
            Explore the complete collection of stories published under Leavitt Peak Press
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default BooksHero;
